















import { Component, Ref, Vue } from 'vue-property-decorator';
import EventHeader from '@/components/event/EventHeader.vue';
import EventFlow from '@/active-components/event-flow/EventFlow.vue';
import { EventResponse } from '@/model/Event';
import { mapActions, mapGetters, mapMutations } from 'vuex';

@Component({
    components: {
        EventHeader,
        EventFlow,
    },
    computed: {
        ...mapGetters({
            getEvent: 'eventStorage/getEvent',
        }),
    },
    methods: {
        ...mapActions({
            fetchEventById: 'eventStorage/fetchEventById',
        }),
        ...mapMutations({
            setEvent: 'eventStorage/setEvent',
        }),
    },
})
export default class Events extends Vue {
    @Ref() readonly eventFlowRef!: EventFlow;

    fetchEventById!: (id: number) => Promise<void | EventResponse>;

    getEvent!: EventResponse | null;

    setEvent!: (event: EventResponse | null) => void;

    loading = true;

    eventId: number = +this.$route.params.id;

    mounted(): void {
        this.fetchEventById(this.eventId)
            .then(() => {
                document.title = `${this.getEvent?.name} - Cascade`;
            })
            .catch(() => {
                document.title = `${this.$t(
                    'event.not-found',
                ).toString()} - Cascade`;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onShowNewItemModal(): void {
        this.eventFlowRef.onCreate();
    }
}
